import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import doc from "./doc";
import "./assets/main.css";

// 将主题管理器和setTheme函数挂载到window对象，使其能在浏览器控制台中访问
declare global {
  interface Window {
    setTheme: (theme: string) => void;
    titleChannel: any;
  }
}
// window.titleChannel = new BroadcastChannel("titleChannel");

createApp(App).use(doc).use(router).mount("#app");
